var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Task',{attrs:{"blink":"E38000243","target":"Nottingham and Nottinghamshire","allowRiverCross":"true","showRiver":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }